import React from 'react';
import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  IPaginationProps,
  LinearProgress,
  LoadedContent,
} from '@occc-app/design-system';
import { ProductGroupFragment } from '@occc/graphql';

import { ProductGroupTableRow } from './ProductGroupTableRow';

type ProductGroupsTableProps = {
  productGroups?: ProductGroupFragment[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  isUserPermittedToEditProductGroup: boolean;
  isUserPermittedToDeleteProductGroup: boolean;
};

export const ProductGroupsTable = ({
  productGroups,
  loading,
  error,
  paginationProps,
  isUserPermittedToEditProductGroup,
  isUserPermittedToDeleteProductGroup,
}: ProductGroupsTableProps) => {
  const areActionsVisible =
    isUserPermittedToEditProductGroup || isUserPermittedToDeleteProductGroup;
  const renderData = (items: ProductGroupFragment[]) => (
    <>
      {loading && <LinearProgress />}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Identifier</TableCell>
            <TableCell align='center'>Total</TableCell>
            <TableCell align='center'>TAR Eligible</TableCell>
            <TableCell align='center'>Rank</TableCell>
            {areActionsVisible && <TableCell align='right'>Actions</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((productGroup) => (
            <ProductGroupTableRow
              key={productGroup.id}
              productGroup={productGroup}
              isUserPermittedToEditProductGroup={isUserPermittedToEditProductGroup}
              isUserPermittedToDeleteProductGroup={isUserPermittedToDeleteProductGroup}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </>
  );

  return (
    <LoadedContent<ProductGroupFragment>
      error={error}
      loading={loading}
      items={productGroups}
      renderData={renderData}
    />
  );
};
